import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'material-ui';
import { push as pushAction } from 'react-router-redux';
import {
  updateSameAsCorporatePolicyNotes as updateSameAsCorporatePolicyNotesAction,
} from '../../__storeFiles__/actions';
import injectCss from 'react-jss';

const OverwriteBtnIndicator = props => {
  const {
    templateDraftId,
    sectionValue,
    masterTemplateApplied,
    updateSameAsCorporatePolicyNotes,
    editable,
  } = props;
  return (
    <Checkbox
      checked={masterTemplateApplied}
      disabled={!editable}
      iconStyle={{
        width: '20px',
        height: '20px',
        top: '2px',
      }}
      style={{
        width: '260px',
        display: 'flex',
        alignItems: 'center',
        right: '-24px',
      }}
      labelStyle={{ fontSize: '12px' }}
      labelPosition="left"
      label="Same as Corporate Policies & Notes"
      onCheck={() => {
        updateSameAsCorporatePolicyNotes(templateDraftId, sectionValue, !masterTemplateApplied);
      }}
    />
  );
};

OverwriteBtnIndicator.propTypes = {
  push: PropTypes.func,
  updateSameAsCorporatePolicyNotes: PropTypes.func,
  masterTemplateApplied: PropTypes.bool,
  templateDraftId: PropTypes.string,
  sectionValue: PropTypes.string,
  editable: PropTypes.bool,
};

export default connect(null, {
  push: pushAction,
  updateSameAsCorporatePolicyNotes: updateSameAsCorporatePolicyNotesAction,
})(injectCss({

})(OverwriteBtnIndicator));



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/btns-switches/sameAs-checkbox.jsx